module.exports = __webpack_public_path__ + "img/brittleLava.cead5a0e.jpg";